module.exports = __webpack_public_path__ + "img/a3-s38.e84ebf64.jpg";